<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Email Templates
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="nav-tree">
            <el-button v-if="companyLayout" :disabled="!companyLayout.permission.changeCompanyMailTemplates" @click="openModalHeaderFooter" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_mailTemplates_headerFooter')}}</el-button>
            <el-button v-if="companyLayout" :disabled="!companyLayout.permission.changeCompanyMailTemplates" @click="updateToDefaultAll" class="nav-tree__item" size="mini" type="warning" plain icon="el-icon-refresh">{{$t('settings_mailTemplates_updateToDefaultAll')}}</el-button>
          </div>

          <el-table
            max-height="720"
            :data="tableData"
            :empty-text="$t('general_noData')"
            style="width: 100%">
            <!-- <el-table-column
              label="ID"
              type="index"
              width="50">
            </el-table-column> -->
            <el-table-column
              width="50"
              prop="serialNumber"
              label="ID">
          </el-table-column>
            <el-table-column
              :label="$t('settings_mailTemplates_description')">
              <template slot-scope="scope">
                <span :class="{ active: scope.row.active, inactive: !scope.row.active }">{{scope.row.description}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              width="250"
              :label="$t('settings_mailTemplates_operations')">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  plain
                  icon="el-icon-refresh"
                  v-if="companyLayout"
                  :disabled="!companyLayout.permission.changeCompanyMailTemplates"
                  @click="updateToDefault(scope.row.id)"></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  v-if="companyLayout"
                  :disabled="!companyLayout.permission.changeCompanyMailTemplates"
                  @click="handleEdit(scope.row.id)"></el-button>
                <el-button
                  size="mini"
                  :type="scope.row.active ? 'danger' : 'success'"
                  plain
                  :icon="scope.row.active ? 'el-icon-circle-close' : 'el-icon-circle-plus-outline'"
                  @click="inactiveAndActive(scope.row.active, scope.row.id)">{{ scope.row.active ? $t('settings_mailTemplates_inactive') : $t('settings_mailTemplates_active')}}</el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>

    <!-- add -->
    <sweet-modal blocking :title="$t('settings_mailTemplates_headerFooter')" ref="openModal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item>
              <div>{{$t('settings_mailTemplates_header')}}</div>
              <vue-editor
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="form.header"></vue-editor>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <div>{{$t('settings_mailTemplates_footer')}}</div>
              <vue-editor
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="form.footer"></vue-editor>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addHeaderFooter('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- edit -->
    <sweet-modal blocking :title="$t('settings_mailTemplates_edit')" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item>
                <el-input :disabled="true" :label="$t('settings_mailTemplates_description')" v-model="formEdit.description"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="subjectTemplate">
                <el-input :label="$t('settings_mailTemplates_subject')" v-model="formEdit.subjectTemplate"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-input :label="$t('settings_mailTemplates_textTemplate')" v-model="formEdit.textTemplate"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <div v-html="formEdit.params"></div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <div style="color: #A9A9A9;">{{$t('settings_mailTemplates_htmlTemplate')}}</div>
                <vue-editor
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  v-model="formEdit.htmlTemplate"></vue-editor>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item class="modal__btn">
            <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
            <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { VueEditor } from 'vue2-editor'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      VueEditor,
      SweetModal,
    },
    beforeCreate() {},
    created () {
      this.loadList()
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        tableData: [],
        selectedRowId: '',
        moment:moment,
        form:{
          header: '',
          footer: '',
        },
        formEdit:{
          description: '',
          textTemplate: '',
          htmlTemplate: '',
          subjectTemplate: '',
          params: '',
        },
        rulesEdit: {
          subjectTemplate: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      inactiveAndActive(active, id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyMailTemplate/updateStatus?companyId=${this.$route.query.companyId}&mailTemplateId=${id}`, {
            active: !active
          })
          .then(response => {
              // TODO
              this.loadList()
              loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyMailTemplate/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
              this.tableData = response.data.list.mailTemplatesList
              loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      addHeaderFooter(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyMailTemplate/HFupdate?companyId=${this.$route.query.companyId}&type=company`, {
                header: this.form.header,
                footer: this.form.footer
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      openModalHeaderFooter(){
        this.$refs.openModal.open()

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyMailTemplate/HFitem?companyId=${this.$route.query.companyId}&type=company`)
          .then(response => {
            this.$refs.openModal.open()
            this.form.header = response.data.item.header
            this.form.footer = response.data.item.footer
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      updateToDefaultAll() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/notifications/companyMailTemplate/update-to-default-all?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.loadList()
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      updateToDefault(id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/notifications/companyMailTemplate/update-to-default?companyId=${this.$route.query.companyId}&mailTemplateId=${id}`)
          .then(response => {
            this.loadList()
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      closeModal(){
        this.form.header = ''
        this.form.footer = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.description = ''
        this.formEdit.textTemplate = ''
        this.formEdit.htmlTemplate = ''
        this.formEdit.subjectTemplate = ''
        this.formEdit.params = ''
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(id) {
        this.selectedRowId = id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyMailTemplate/item?companyId=${this.$route.query.companyId}&mailTemplateId=${id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.description = response.data.item.description
            this.formEdit.textTemplate = response.data.item.textTemplate
            this.formEdit.htmlTemplate = response.data.item.htmlTemplate
            this.formEdit.subjectTemplate = response.data.item.subjectTemplate
            this.formEdit.params = response.data.item.params
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyMailTemplate/update?companyId=${this.$route.query.companyId}&mailTemplateId=${this.selectedRowId}`, {
                textTemplate: this.formEdit.textTemplate,
                htmlTemplate: this.formEdit.htmlTemplate,
                subjectTemplate: this.formEdit.subjectTemplate,
              })
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        let loader = this.$loading.show();
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        // console.log('---', this.form.imageUrl);
        var formData = new FormData();
        formData.append('file', file);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            let url = response.data.fileUrl // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
